import { AxiosResponse } from "axios";
import API from "../api";

import { ItemJobToStorageBox, StorageBox, StorageBoxAssociateJob } from "../models/storage.box";
import { ItemJob } from "../models/sales";
import { MapCell } from "../models/warehouse.mapcell";
import { Job } from "../models/job";
import { Movement } from "../models/movement";
import { User } from "../models/user";

const ROUTE_NAME = "warehousing";

export interface PropsMove {
  mapCell: MapCell;
  storageBox?: StorageBox;
  itemJob?: ItemJob;
}

export interface PropsUnload {
  storageBox: StorageBox;
  jobs: Array<Job>;
}

export interface PropsClear {
  id: number;
}

export interface UnloadItemJobInStorageBox {
  storageBoxId?: number;
  itemJobId: number;
}

const WarehousingService = {
  async getAllMovements(options?: any): Promise<AxiosResponse<Movement[]>> {
    return await API.get(`/${ROUTE_NAME}/movement`, { params: options });
  },
  async getAllUsersMovements(
    options?: any
  ): Promise<AxiosResponse<Pick<User, "id" | "fullName">[]>> {
    return await API.get(`/${ROUTE_NAME}/movement/users`, { params: options });
  },
  async countMovements(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/movement/count`, { params: options });
  },
  async movement(move: PropsMove): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/movement`, move);
  },
  async unloadAllByJobs(unload: PropsUnload): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/storage-box/unload/all`, unload);
  },
  async clearMapCell(clear: PropsClear): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/clear`, clear);
  },
  async setJobAndStorageRelation(data: StorageBoxAssociateJob): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/storage-box/associate-job`, data);
  },
  async moveItemJobToStorageBox(data: ItemJobToStorageBox): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/storage-box/load`, data);
  },
  async unloadItemJobInStorageBox(
    data: UnloadItemJobInStorageBox
  ): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/storage-box/unload/one`, data);
  },
};

export default WarehousingService;
